import api from '@/api/fetch'

export function getLocations() {
  return api.get('/locations').then(res => res.data)
}

export function getLocation() {
  return api.get('/location').then(res => res.data)
}
